import { Controller as t } from "@hotwired/stimulus";

function e(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, n(t, e);
}

function n(t, e) {
  return n = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  }, n(t, e);
}

var o = function (t) {
  function n() {
    return t.apply(this, arguments) || this;
  }

  e(n, t);
  var o = n.prototype;
  return o.connect = function () {
    this.autohideValue && this.setInterval();
  }, o.setInterval = function () {
    var t = this;
    setTimeout(function () {
      return t.close();
    }, this.autohideDelayValue);
  }, o.close = function () {
    var t = this;
    this.stopInterval(), this.element.style.opacity = "0", setTimeout(function () {
      return t.element.remove();
    }, 300);
  }, o.disconnect = function () {
    this.stopInterval();
  }, o.stopInterval = function () {
    clearTimeout(this.setInterval);
  }, n;
}(t);

o.values = {
  autohide: {
    type: Boolean,
    "default": !0
  },
  autohideDelay: {
    type: Number,
    "default": 2e3
  }
};

var r = function (t) {
  function n() {
    return t.apply(this, arguments) || this;
  }

  e(n, t);
  var o = n.prototype;
  return o.format = function () {
    this.outputTarget.value = this.slugify(this.inputTarget.value);
  }, o.slugify = function (t) {
    return t.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
  }, n;
}(t);

r.targets = ["input", "output"];

var i = function (t) {
  function n() {
    return t.apply(this, arguments) || this;
  }

  var o;
  return e(n, t), n.prototype.toggle = function (t) {
    var e = this;
    t.preventDefault(), this.toggleableTargets.forEach(function (t) {
      t.classList.toggle(e.classToToggle);
    });
  }, (o = [{
    key: "classToToggle",
    get: function get() {
      return this.hasHiddenClass ? this.hiddenClass : "d-none";
    }
  }]) && function (t, e) {
    for (var n = 0; n < e.length; n++) {
      var o = e[n];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
    }
  }(n.prototype, o), n;
}(t);

i.targets = ["toggleable"], i.classes = ["hidden"];
export { o as Flash, r as Slug, i as Toggle };